<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Questão</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="question">Questão</label>
                                    <select name="question[]" id="question" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(question, index) in question">
                                            {{ question.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setQuestions">Ordenar Questão <i
                                        class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(question,index) in selected' :key="question.id"
                                        class="list-group-item clearfix">
                                        <i class="mdi mdi-drag pull-left"></i>
                                        <span class="pull-left stages" :id="'stage' + question.id">{{ index + 1 }}. {{ question.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(question, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar
                                </button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação
                                    <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        data: function () {
            return {
                question: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getQuestionsArray: function (data) {
                let array = [];
                $.each(data, function (index, value) {
                    if (value.sort_by) {
                        array.push(index);
                    }
                });
                return array;
            },
            getQuestions: function () {
                let self = this;
                let api = self.$store.state.api + 'question?paginated=false';
                let question = $('#question');

                self.$http.get(api)
                    .then((response) => {
                        self.question = response.data.data;
                        self.ordered = self.getQuestionsArray(self.question);
                    })
                    .then(() => {
                        question.bootstrapDualListbox();
                        question.ready(function () {
                            question.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Promotional Materials', 'error');
                    });
            },
            setQuestions: function () {
                const self = this;
                let question = self.selected;

                $('#question').find(':selected').each(function () {
                    question.push(self.question[$(this).val()]);
                });

                self.selected = question;
                self.order = true;
            },
            save: function () {
                const self = this;
                $.each(self.selected, function (index, value) {
                    const api = self.$store.state.api + 'question/' + value.id;
                    self.$http.put(api, {
                        sort_by: (index + 1)
                    });
                });
                self.ordered = self.getQuestionsArray(self.selected);
                self.$message(null, 'Ordenação salva com sucesso', 'success');
            },
            remove: function (question, index) {
                const self = this;
                const api = self.$store.state.api + 'question/' + question.id;

                let array = [];
                $.each(self.selected, function (key, value) {
                    if (index !== key) {
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function () {
                window.location.reload();
            }
        },
        mounted: function () {
            this.getQuestions();
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/QuestionOrder/Index.vue